import { render, staticRenderFns } from "./RequestCampaignApprovalWidget.vue?vue&type=template&id=537b6f17"
import script from "./RequestCampaignApprovalWidget.vue?vue&type=script&lang=js"
export * from "./RequestCampaignApprovalWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports